import { useRouter } from "next/router";
import ErrorPage from "next/error";
import Head from "next/head";
import Layout from "../../components/Layout";
import CaseStudyHero from "../../components/CaseStudyHero";
import { CaseStudyStats } from "../../components/CaseStudyStats";
import { getCaseStudyBySlug, getAllCaseStudies } from "../../lib/caseStudies";
import dynamic from "next/dynamic";
import NextUp from "../../components/NextUp";
import ContactUsPreFooter from "../../components/ContactUsPreFooter";
const CaseStudySection = dynamic(
  () => import("../../components/CaseStudySection"),
  { ssr: false }
);
export default function CaseStudy({ caseStudy, nextUpCaseStudy }) {
  const router = useRouter();
  if (!router.isFallback && !caseStudy?.slug) {
    return <ErrorPage statusCode={404} />;
  }
  return (
    <Layout noMargin noMarginTop isCaseStudy={!caseStudy.useWhiteHeader}>
      {router.isFallback ? (
        <div>Loading…</div>
      ) : (
        <>
          <article className="mb-8 sm:mb-16">
            <Head>
              <title>{caseStudy.title} | Eventive Case Studies</title>
            </Head>
            <CaseStudyHero
              title={caseStudy.title}
              subtitle={caseStudy.subtitle}
              background={caseStudy.hero}
              hasStats={caseStudy?.stats?.length > 0}
              negativeMarginTop={!caseStudy.useWhiteHeader}
            />
            {caseStudy.stats && (
              <div className="relative z-10 -mt-10 lg:-mt-17 w-full mx-auto max-w-7xl px-4 sm:px-6">
                <CaseStudyStats stats={caseStudy.stats} />
              </div>
            )}
            {caseStudy.challenge && (
              <CaseStudySection
                type="challenge"
                content={caseStudy.challenge}
              />
            )}
            {caseStudy.solution && (
              <CaseStudySection type="solution" content={caseStudy.solution} />
            )}
            {caseStudy.nextup && (
              <NextUp
                caseStudy={nextUpCaseStudy}
                segue={caseStudy.nextUpSegue}
              />
            )}

            <ContactUsPreFooter />
          </article>
        </>
      )}
    </Layout>
  );
}

export async function getStaticProps({ params }) {
  const caseStudy = getCaseStudyBySlug(params.slug, [
    "title",
    "slug",
    "hero",
    "subtitle",
    "stats",
    "challenge",
    "solution",
    "nextup",
    "nextUpSegue",
    "useWhiteHeader",
  ]);

  const nextUpCaseStudy = getCaseStudyBySlug(caseStudy.nextup, [
    "title",
    "slug",
    "hero",
    "linkText",
    "thumbnail",
    "subtitle",
  ]);

  return {
    props: {
      caseStudy,
      nextUpCaseStudy,
    },
  };
}

export async function getStaticPaths() {
  const allCaseStudies = getAllCaseStudies(["slug"]);
  return {
    paths: allCaseStudies.map(caseStudy => {
      return {
        params: {
          slug: caseStudy.slug,
        },
      };
    }),
    fallback: false,
  };
}
